import React from 'react';
import {Modal, Grid, Stack, Title, Text, Badge, Divider, ScrollArea, Flex, Card} from '@mantine/core';


const TaskModal = ({ opened, onClose, task }) => {
    if (!task) return null;

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            size="100%"
            padding="lg"
            centered
            radius={8}
            transitionProps={{ transition: 'fade', duration: 200 }}
            scrollAreaComponent={ScrollArea.Autosize}
            title={
                <span className='titleModalKanban'>
                    {task.title}
                </span>
            }
        >
            <Flex gap={'md'}>
                <Card style={{ flex: 2}} >
                    <Card.Section inheritPadding mt="sm">
                        <Card withBorder shadow="xs" mb="md">
                            <Card.Section withBorder inheritPadding py="xs">
                                <Text weight={500} size="sm" color="dimmed">Resumen</Text>
                            </Card.Section>
                            <Text size="sm" p="sm" style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
                                {task.summary || 'Sin resumen disponible'}
                            </Text>
                        </Card>

                        <Grid gutter="md" mb="md">
                            <Grid.Col span={6}>
                                <Card withBorder shadow="xs" h="100%">
                                    <Stack spacing="xs">
                                        <Flex align="center" gap="xs">
                                            <div className="icon-hash" style={{ fontSize: '16px', color: '#495057' }}></div>
                                            <Text weight={500} size="sm" color="dimmed">Código</Text>
                                        </Flex>
                                        <Text size="sm" weight={500}>{task.code || 'Sin código'}</Text>
                                    </Stack>
                                </Card>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Card withBorder shadow="xs" h="100%">
                                    <Stack spacing="xs">
                                        <Flex align="center" gap="xs">
                                            <i className={task.activity_status?.icon || 'icon-clock'} 
                                               style={{ fontSize: '16px', color: task.activity_status?.txcolor || '#495057' }}></i>
                                            <Text weight={500} size="sm" color="dimmed">Estado</Text>
                                        </Flex>
                                        <Badge 
                                            size="md" 
                                            style={{
                                                backgroundColor: task.activity_status?.bgcolor || '#e9ecef',
                                                color: task.activity_status?.txcolor || '#495057'
                                            }}
                                        >
                                            {task.activity_status?.name || 'Sin estado'}
                                        </Badge>
                                    </Stack>
                                </Card>
                            </Grid.Col>
                        </Grid>

                        <Grid gutter="md" mb="md">
                            <Grid.Col span={4}>
                                <Card withBorder shadow="xs" h="100%">
                                    <Stack spacing="xs">
                                        <Flex align="center" gap="xs">
                                            <i className={task.activity_group?.icon || 'icon-users'} 
                                               style={{ fontSize: '16px', color: task.activity_group?.txcolor || '#495057' }}></i>
                                            <Text weight={500} size="sm" color="dimmed">Grupo</Text>
                                        </Flex>
                                        <Text size="sm" weight={500}>{task.activity_group?.name || 'Sin grupo'}</Text>
                                    </Stack>
                                </Card>
                            </Grid.Col>
                            <Grid.Col span={4}>
                                <Card withBorder shadow="xs" h="100%">
                                    <Stack spacing="xs">
                                        <Flex align="center" gap="xs">
                                            <div className="icon-file-text" style={{ fontSize: '16px', color: '#495057' }}></div>
                                            <Text weight={500} size="sm" color="dimmed">Tipo</Text>
                                        </Flex>
                                        <Text size="sm" weight={500}>{task.activity_type?.name || 'Sin tipo'}</Text>
                                    </Stack>
                                </Card>
                            </Grid.Col>
                            <Grid.Col span={4}>
                                <Card withBorder shadow="xs" h="100%">
                                    <Stack spacing="xs">
                                        <Flex align="center" gap="xs">
                                            <i className={task.activity_priority?.icon || 'icon-trending-up'} 
                                               style={{ fontSize: '16px', color: task.activity_priority?.txcolor || '#f57c00' }}></i>
                                            <Text weight={500} size="sm" color="dimmed">Prioridad</Text>
                                        </Flex>
                                        <Badge 
                                            size="md" 
                                            style={{
                                                backgroundColor: task.activity_priority?.bgcolor || '#e9ecef',
                                                color: task.activity_priority?.txcolor || '#495057'
                                            }}
                                        >
                                            {task.activity_priority?.name || 'Sin prioridad'}
                                        </Badge>
                                    </Stack>
                                </Card>
                            </Grid.Col>
                        </Grid>

                        <Card withBorder shadow="xs" mb="md">
                            <Stack spacing="xs">
                                <Flex align="center" gap="xs">
                                    <div className="icon-building" style={{ fontSize: '16px', color: '#1976d2' }}></div>
                                    <Text weight={500} size="sm" color="dimmed">Establecimiento</Text>
                                </Flex>
                                <Text size="sm" weight={500}>{task.establishment?.name || 'Sin establecimiento'}</Text>
                                {task.establishment?.code_siep && (
                                    <Text size="xs" color="dimmed">Código SIEP: {task.establishment.code_siep}</Text>
                                )}
                            </Stack>
                        </Card>

                        <Card withBorder shadow="xs" mb="md">
                            <Card.Section withBorder inheritPadding py="xs">
                                <Flex align="center" gap="xs">
                                    <div className="icon-message-square" style={{ fontSize: '16px', color: '#495057' }}></div>
                                    <Text weight={500} size="sm" color="dimmed">Comentarios</Text>
                                </Flex>
                            </Card.Section>
                            <Text size="sm" p="sm" style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
                                {task.comment ? task.comment : 'No hay comentarios'}
                            </Text>
                        </Card>


                        
                    </Card.Section>
                </Card>

                <Card style={{ flex: 1 }} mt={'md'}>
                    <Card.Section inheritPadding spacing="sm">
                        <Title order={5} mb="sm" color="dark">Características de la actividad de control</Title>

                        <Flex justify="space-between" align="center" py="xs">
                            <Text size="sm" color="dimmed">Tipo</Text>
                            <Flex align="center" gap="xs">
                                <div className="icon-file-text" style={{ fontSize: '14px', color: '#666' }}></div>
                                <Text size="sm">{task.activity_type?.name || 'No especificado'}</Text>
                            </Flex>
                        </Flex>

                        <Flex justify="space-between" align="center" py="xs">
                            <Text size="sm" color="dimmed">Grupo</Text>
                            <Flex align="center" gap="xs">
                                <i className={task.activity_group?.icon || 'icon-users'} style={{ fontSize: '14px', color: task.activity_group?.txcolor || '#666' }}></i>
                                <Text size="sm">{task.activity_group?.name || 'No especificado'}</Text>
                            </Flex>
                        </Flex>

                        <Flex justify="space-between" align="center" py="xs">
                            <Text size="sm" color="dimmed">Prioridad</Text>
                            <Flex align="center" gap="xs">
                                <i className={task.activity_priority?.icon || 'icon-trending-up'} style={{ fontSize: '14px', color: task.activity_priority?.txcolor || '#f57c00' }}></i>
                                <Badge 
                                    size="sm" 
                                    style={{
                                        backgroundColor: task.activity_priority?.bgcolor || '#gray',
                                        color: task.activity_priority?.txcolor || '#white'
                                    }}
                                >
                                    {task.activity_priority?.name || 'No especificada'}
                                </Badge>
                            </Flex>
                        </Flex>

                        <Flex justify="space-between" align="center" py="xs">
                            <Text size="sm" color="dimmed">Estado</Text>
                            <Flex align="center" gap="xs">
                                <i className={task.activity_status?.icon || 'icon-clock'} style={{ fontSize: '14px', color: task.activity_status?.txcolor || '#666' }}></i>
                                <Badge 
                                    size="sm" 
                                    style={{
                                        backgroundColor: task.activity_status?.bgcolor || '#gray',
                                        color: task.activity_status?.txcolor || '#white'
                                    }}
                                >
                                    {task.activity_status?.name || 'No especificado'}
                                </Badge>
                            </Flex>
                        </Flex>

                        <Flex justify="space-between" align="center" py="xs">
                            <Text size="sm" color="dimmed">Fecha Inicio</Text>
                            <Flex align="center" gap="xs">
                                <div className="icon-calendar" style={{ fontSize: '14px', color: '#666' }}></div>
                                <Text size="sm">{task.start ? new Date(task.start).toLocaleDateString('es-ES') : 'No especificada'}</Text>
                            </Flex>
                        </Flex>

                        <Flex justify="space-between" align="center" py="xs">
                            <Text size="sm" color="dimmed">Fecha Fin</Text>
                            <Flex align="center" gap="xs">
                                <div className="icon-calendar" style={{ fontSize: '14px', color: '#666' }}></div>
                                <Text size="sm">{task.end ? new Date(task.end).toLocaleDateString('es-ES') : 'No especificada'}</Text>
                            </Flex>
                        </Flex>

                                   

                        <Divider my="md" />


                        <Title order={5} mb="sm" color="dark">Información adicional</Title>

                        <Flex justify="space-between" align="center" py="xs">
                            <Text size="sm" color="dimmed">Establecimiento</Text>
                            <Flex align="center" gap="xs">
                                <div className="icon-building" style={{ fontSize: '14px', color: '#1976d2' }}></div>
                                <Text size="sm">{task.establishment?.name || 'No asignado'}</Text>
                            </Flex>
                        </Flex>

                        <Flex justify="space-between" align="center" py="xs">
                            <Text size="sm" color="dimmed">Código SIEP</Text>
                            <Flex align="center" gap="xs">
                                <div className="icon-hash" style={{ fontSize: '14px', color: '#666' }}></div>
                                <Text size="sm">{task.establishment?.code_siep || 'No especificado'}</Text>
                            </Flex>
                        </Flex>
                    </Card.Section>
                </Card>
            </Flex>
        </Modal>
    );
};

export default TaskModal;